module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Header/images/draw-ribbon.19b18ab5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Header/images/draw-ribbon.png
// module id = 3235
// module chunks = 11